import { render, staticRenderFns } from "./FussFreeLicensing2026.vue?vue&type=template&id=20092122&scoped=true&"
import script from "./FussFreeLicensing2026.vue?vue&type=script&lang=js&"
export * from "./FussFreeLicensing2026.vue?vue&type=script&lang=js&"
import style0 from "./FussFreeLicensing2026.vue?vue&type=style&index=0&id=20092122&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20092122",
  null
  
)

export default component.exports